const _ = require('lodash');

module.exports = function () {
    return function (collectionZoneItems, searchTerm) {
        return _.filter(collectionZoneItems, function (collectionZoneItem) {
            // True if searchTerm is falsy/empty or if search term matches Quantity, Name, PackageSize, or SalePrice
            return !searchTerm
                || _.includes([
                    typeof collectionZoneItem.Name !== 'undefined'
                    ? collectionZoneItem.Name.toLowerCase().replace(/\s{2,}/g, ' ')
                    : collectionZoneItem.Name, collectionZoneItem.PackageSize, collectionZoneItem.Quantity, `$${collectionZoneItem.SalePrice}`
                ].join(' '), searchTerm.toLowerCase().replace(/\s{2,}/g, ' '));
        });
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/collection-zone-search-filter.js
 **/